<template>
	<BaseCard :is-editable="isEditable && !!person" :title="$t('customer').toString()" :is-toggleable="false" @clickEdit="edit">
		<div v-if="person">
			<BaseCardRow v-if="person.organisation" :value="person.organisation" :label="$t('company')" />

			<BaseCardRow :value="name" :label="$t('name')" />

			<BaseCardRow :value="street" :label="$t('street')" />

			<BaseCardRow :value="city" :label="$t('city')" />

			<BaseCardRow :value="phone" :label="$t('phone')" class="mt-6" />

			<BaseCardRow :value="person.email" :label="$t('e_mail')" />
		</div>

		<div v-else class="font-bold">{{ $t('customer') }} {{ $t('not_stored') }}</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'DamageAssessorCasePersonCard',

	components: {
		BaseCard,
		BaseCardRow,
	},

	props: {
		person: {
			type: Object,
			default: null,
		},

		caseId: {
			type: [Number, String],
			required: true,
		},

		isEditable: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		name() {
			if (!this.person) {
				return '-';
			}

			return concatArray([this.person.title, this.person.firstName, this.person.lastName]) || '-';
		},
		street() {
			if (!this.person) {
				return '-';
			}

			if (!this.person.street) {
				return this.person.poBox ?? '-';
			}

			return concatArray([this.person.street, this.person.houseNumber]) || '-';
		},
		city() {
			if (!this.person?.city) {
				return '-';
			}

			return concatArray([this.person.city.zipCode, this.person.city.name]) || '-';
		},
		phone() {
			return this.person?.cellNumber ?? this.person?.phoneNumber ?? '-';
		},
	},

	methods: {
		edit() {
			this.$router.push({
				name: 'damageAssessorCaseEditPerson',
				params: {
					id: this.caseId,
				},
			});
		},
	},
};
</script>
